import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { cn } from '@bem-react/classname'

import { useHandleServerError } from '@/hooks/useHandleServerError'

import { Button } from '@/components/UI/Button'
import { Loading } from '@/components/UI/Loading'
import { Title } from '@/components/UI/Title'

import './Orders.scss'
import { OrderOperations } from './components/OrderOperations'
import { ordersSelector } from './store/OrdersSelector'
import { getOrdersThunk } from './store/OrdersSlice'

const cnOrders = cn('Orders')

export const Orders: FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleServerError } = useHandleServerError()

  const orders = useAppSelector(ordersSelector)

  const [isLoading, setLoading] = useState<boolean>(true)
  const [isLoadingData, setLoadingData] = useState<boolean>(true)
  const [size, setSize] = useState<number>(4)

  useEffect(() => {
    getOrders(size)
  }, [size])

  const getOrders = async (perPage = 4) => {
    try {
      await dispatch(getOrdersThunk(perPage))
      setLoading(false)
      setLoadingData(false)
    } catch (error) {
      handleServerError(error)
      setLoading(false)
      setLoadingData(false)
    }
  }

  const loadData = async () => {
    setLoadingData(true)
    setSize(size + 4)
  }

  return (
    <>
      {isLoading ? (
        <Loading type='circle' minHeight='300px' />
      ) : (
        <div className={cnOrders()}>
          <Title>{t('orders-title')}</Title>
          <OrderOperations orders={orders} />

          {orders && (
            <Button
              color='blue'
              disabled={size >= orders.total}
              onClick={loadData}
              isLoading={isLoadingData}
            >
              {t('orders-btn')}
            </Button>
          )}
        </div>
      )}
    </>
  )
}
